export const fontFamily = "'Roboto', sans-serif";
export const fontFamilyAlt = "'Mulish', sans-serif";
export const fontFamilyOpenSans = "'Open Sans', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    maxMD: "@media screen and (max-width: 767px)",
    maxLG: "@media screen and (max-width: 1023px)",
    maxXLG: "@media screen and (max-width: 1199px)",
    maxWide: "@media screen and (max-width: 1399px)",
    minSM: "@media screen and (min-width: 425px)",
    minMD: "@media screen and (min-width: 768px)",
    minLG: "@media screen and (min-width: 1024px)",
    minXLG: "@media screen and (min-width: 1200px)",
    minWide: "@media screen and (min-width: 1400px)",
    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

export const colorPalette = {
    primary: {
        main: "#2E4f26",
    },
    secondary: {
        main: "#2E5996",
    },
    success: {
        main: "#019d05",
    },
    danger: {
        main: "#d32e2a",
    },
    warning: {
        main: "#f7b847",
    },
    info: {
        main: "#5678aa",
    },
    successBg: {
        main: "#ffffff",
    },
    dangerBg: {
        main: "#ffffff",
    },
    warningBg: {
        main: "#fef7ec",
    },
    infoBg: {
        main: "#f6f8fb",
    },
    common: {
        background: "#FFF",
        border: "#A5A5A5",
        global: {
            white: "#FFF",
            black: "#000",

            // Brand Colors
            fieldGreen: "#2E4F26",
            industrialTaupe: "#B89E7D",
            waytekRed: "#D32E2A",
            twilightBlue: "#0E346A",
            guardianBlue: "#2E5996",
            loyalBlue: "#5678AA",

            // Secondary Colors
            secondaryGray: "#4a4a4a",
            ice: "#F6F9F8",
            fadedTaupe: "#FBFAF8",

            // Gray Colors
            darkerGray: "#252525",
            darkGray: "#63666A",
            mediumDarkGray: "#888B8D",
            mediumLightGray: "#A7A8AA",
            lightGray: "#C8C9C7",
            extraLight: "#F3F3F3",
            disabledLabel: "#909090",
            disabledBg: "#f0f0f0",
            disabledButtonBg: "#fafafa",

            // Footer Colors
            footerSection1: "#576952",
            footerSection2: "#819C79",
            footerSection3: "#FFFFFF",

            // UI
            errorRed: "#ff0000",

            // Dynamic Dropdown
            dynamicDropdownBgHover: "#f3f3f3",
            dynamicDropdownBorder: "#979797",

            // Modal
            modalTitleBgGreen: "#2f4f26",
            modalTitleBgYellow: "#f7b847",

            // Table
            dataTableHeaderBg: "#2f4f26",
            dataTableHeaderColor: "#ffffff",
            dataTableRowEvenBg: "#fbfaf8",
            dataTableRowOddBg: "#ffffff",
            dataTableRowDivider: "#bbbbbb",
            dataTableRowColor: "#4a4a4a",

            // Radio
            radioBorderColor: "#999999",
            radioBackgroundColor: "#EEEEEE",
            radioChecked: "#2f4f26",
        },
    } as any,
    text: {
        main: "#4A4A4A",
        link: "#2e5996",
    },
    uiSuccess: {
        main: "#018905",
        contrast: "#F6F9F8",
    },
    uiWarning: {
        main: "#F7B847",
        contrast: "#4A4A4A",
    },
    uiDanger: {
        main: "#D32E2A",
        contrast: "#F6F9F8",
    },
};

export const colorStrings = {
    primaryMain: "primary.main",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    warningMain: "warning.main",
    infoMain: "info.main",
    successBgMain: "successBg.main",
    dangerBgMain: "dangerBg.main",
    warningBgMain: "warningBg.main",
    infoBgMain: "infoBg.main",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    common: "common",
    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalFieldGreen: "common.global.fieldGreen",
    commonGlobalIndustrialTaupe: "common.global.industrialTaupe",
    commonGlobalWaytekRed: "common.global.waytekRed",
    commonGlobalErrorRed: "common.global.errorRed",
    commonGlobalDynamicDropdownBgHover: "common.global.dynamicDropdownBgHover",
    commonGlobalDynamicDropdownBorder: "common.global.dynamicDropdownBorder",
    commonGlobalModalTitleBgGreen: "common.global.modalTitleBgGreen",
    commonGlobalDataTableHeaderBg: "common.global.dataTableHeaderBg",
    commonGlobalDataTableHeaderColor: "common.global.dataTableHeaderColor",
    commonGlobalDataTableRowEvenBg: "common.global.dataTableRowEvenBg",
    commonGlobalDataTableRowOddBg: "common.global.dataTableRowOddBg",
    commonGlobalDataTableRowDivider: "common.global.dataTableRowDivider",
    commonGlobalDataTableRowColor: "common.global.dataTableRowColor",
    commonGlobalModalTitleBgYellow: "common.global.modalTitleBgYellow",
    commonGlobalTwilightBlue: "common.global.twilightBlue",
    commonGlobalGuardianBlue: "common.global.guardianBlue",
    commonGlobalLoyalBlue: "common.global.loyalBlue",
    commonGlobalSecondaryGray: "common.global.secondaryGray",
    commonGlobalIce: "common.global.ice",
    commonGlobalFadedTaupe: "common.global.fadedTaupe",
    commonGlobalDarkerGray: "common.global.darkerGray",
    commonGlobalDarkGray: "common.global.darkGray",
    commonGlobalMediumDarkGray: "common.global.mediumDarkGray",
    commonGlobalMediumLightGray: "common.global.mediumLightGray",
    commonGlobalLightGray: "common.global.lightGray",
    commonGlobalExtraLight: "common.global.extraLight",
    commonGlobalDisabledLabel: "common.global.disabledLabel",
    commonGlobalDisabledBg: "common.global.disabledBg",
    commonGlobalDisabledButtonBg: "common.global.disabledButtonBg",
    commonGlobalFooterSection1: "common.global.footerSection1",
    commonGlobalFooterSection2: "common.global.footerSection2",
    commonGlobalFooterSection3: "common.global.footerSection3",
    uiSuccess: "uiSuccess",
    uiWarning: "uiWarning",
    uiDanger: "uiDanger",
};

export const btFocus = {
    color: colorPalette.common.global.guardianBlue,
    style: "solid",
    width: "1px",
};

export const getScrollbarWidth = () => {
    if (typeof window !== "undefined") {
        return `${window.innerWidth - document.body.clientWidth - 7}px`;
    }

    return "0";
};
